// snow.js - pure JS snowfall effect
const snowCount = 50; // number of flakes
const flakes = [];

// Create snowflakes
for (let i = 0; i < snowCount; i++) {
  const flake = document.createElement('div');
  flake.className = 'flake';
  flake.innerText = '❄'; // snowflake character
  flake.style.fontSize = (Math.random() * 20 + 10) + 'px';
  flake.style.opacity = Math.random();
  flake.style.top = Math.random() * window.innerHeight + 'px';
  flake.style.left = Math.random() * window.innerWidth + 'px';
  flake.speed = Math.random() * 2 + 1; // vertical speed
  flake.angle = Math.random() * 2 * Math.PI; // sway angle
  flakes.push(flake);
  document.body.appendChild(flake);
}

// Animate flakes
function animate() {
  for (let flake of flakes) {
    let top = parseFloat(flake.style.top);
    let left = parseFloat(flake.style.left);

    top += flake.speed;
    left += Math.sin(flake.angle) * 2; // horizontal sway
    flake.angle += 0.01;

    if (top > window.innerHeight) top = -20;
    if (left > window.innerWidth) left = 0;
    if (left < 0) left = window.innerWidth;

    flake.style.top = top + 'px';
    flake.style.left = left + 'px';
  }
  requestAnimationFrame(animate);
}

animate();

// Update flakes on window resize
window.addEventListener('resize', () => {
  for (let flake of flakes) {
    if (parseFloat(flake.style.left) > window.innerWidth) {
      flake.style.left = Math.random() * window.innerWidth + 'px';
    }
  }
});
